/**
 * 小程序菜单管理模块路由
 * 对应菜单：小程序菜单 > 底部菜单 / 个人中心菜单
 */

export default [
  // 小程序菜单 - 重定向到底部菜单
  {
    path: 'admin/mini-menu',
    name: 'MiniMenuIndex',
    redirect: '/admin/mini-menu/tabbar',
    meta: {
      requiresAuth: true,
      auth: 'admin-mini-menu',
      title: '小程序菜单'
    }
  },
  // 底部菜单列表
  {
    path: 'admin/mini-menu/tabbar',
    name: 'MiniMenuTabbarList',
    component: () =>
      import(/* webpackChunkName: "mini-menu-tabbar-list" */ '@/views/miniMenu/AppMenuListView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'mini-menu-tabbar-list',
      title: '底部菜单管理',
      position: 'tabbar'
    }
  },
  // 底部菜单添加/编辑
  {
    path: 'admin/mini-menu/tabbar/edit',
    name: 'MiniMenuTabbarEdit',
    component: () =>
      import(/* webpackChunkName: "mini-menu-tabbar-edit" */ '@/views/miniMenu/AppMenuEditView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'mini-menu-tabbar-edit',
      title: '添加/编辑底部菜单',
      position: 'tabbar',
      hidden: true
    }
  },
  // 个人中心菜单列表
  {
    path: 'admin/mini-menu/mine',
    name: 'MiniMenuMineList',
    component: () =>
      import(/* webpackChunkName: "mini-menu-mine-list" */ '@/views/miniMenu/AppMenuListView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'mini-menu-mine-list',
      title: '个人中心菜单管理',
      position: 'mine'
    }
  },
  // 个人中心菜单添加/编辑
  {
    path: 'admin/mini-menu/mine/edit',
    name: 'MiniMenuMineEdit',
    component: () =>
      import(/* webpackChunkName: "mini-menu-mine-edit" */ '@/views/miniMenu/AppMenuEditView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'mini-menu-mine-edit',
      title: '添加/编辑个人中心菜单',
      position: 'mine',
      hidden: true
    }
  }
]
